function isMacLikePlatform() {
  if (typeof navigator === 'undefined') {
    return false;
  }

  return /mac|iphone|ipad|ipod/i.test(navigator.platform || navigator.userAgent || '');
}

export function getModifierKeyLabel() {
  return isMacLikePlatform() ? '⌘' : 'Ctrl';
}

export function formatShortcut(keys: string[]) {
  const mapped = keys.map((key) => (key === 'Mod' ? getModifierKeyLabel() : key));
  return isMacLikePlatform() ? mapped.join('') : mapped.join('+');
}
